var _defs, _rect, _circle, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel3G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-5{fill:none;}.cls-2,.cls-4{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5{stroke:#000;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-4,.cls-5{stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 227,
    height: 457
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 96.19,
    cy: 244.17,
    r: 33.49
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.06,
    cy: 251.73,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-109.93 83.85) rotate(-29.36)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.69,
    cy: 241.82,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-102.81 91.22) rotate(-29.36)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.06,211.8a83.09,83.09,0,0,1-5.33,63.61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.36,238.74a32.54,32.54,0,0,0,25.92-17.24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.85,359.47l-1.38,23.84a8.61,8.61,0,0,0,10.07,9L185.41,371.4a8.61,8.61,0,0,0,4.87-14.29l-15.54-17a8.6,8.6,0,0,0-6.93-2.79A746.17,746.17,0,0,0,63.62,351.54,8.59,8.59,0,0,0,56.85,359.47Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.87,298.61a12.67,12.67,0,0,0-8.4,3.92,1.11,1.11,0,0,0-.41.9c.09.46.61.63,1,.71a57.22,57.22,0,0,0,10.46,1.31,18.65,18.65,0,0,0,10-2.58C81.87,299.35,76.66,298.39,72.87,298.61Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.79,302.86c0,30.44,3,40.68,14.36,55.77a43.5,43.5,0,0,0,5.46,5.73,9,9,0,0,0,6.75,2.17c4.24-.36,6-2.53,6-7,0-2.41-1.7-4.77-2.39-7.09l3.54,1a5.69,5.69,0,0,0,1.92.32,2,2,0,0,0,1.63-.92,1.93,1.93,0,0,0-.16-1.87,5.22,5.22,0,0,0-1.4-1.37c-2.46-1.81-6.44-3-9.3-4.07-16.07-13.08-12.48-27-12.48-44.35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.45,291.65a38.09,38.09,0,0,0-9.28,2.16,13,13,0,0,0-7,6.17,44.5,44.5,0,0,0,14.31-4.86,6.7,6.7,0,0,0,1.81-1.29,2.46,2.46,0,0,0,.65-2.05C142.62,291.8,142.3,291.82,142.45,291.65Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.91,298.08c8,23.83,7.17,31.4-.56,40.22,0,0,.08-.59,0,0a15.79,15.79,0,0,0-6.71,3.78,5.29,5.29,0,0,0-1.21,1.54,2.3,2.3,0,0,0-.08,1.92A2.5,2.5,0,0,0,124,346.7a8.71,8.71,0,0,0,2.81-1.16c.6-.31,1.21-.6,1.82-.87,0,.69-.07,1.38-.06,2.07,0,3.42-.61,6.71,1.6,9.31s7.52,3.38,10.7,2.15c3.63-1.4,6.62-5.49,8.67-13.69a84.69,84.69,0,0,0,2-22.56c-.58-9.74-4.44-19.06-9.57-28.58"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.74,256.16a9.48,9.48,0,0,0-6.43,5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.46,267.65a40.42,40.42,0,0,0,2.08,8.85,13.6,13.6,0,0,0,5.62,6.94,11.28,11.28,0,0,0,9.42.59,13.9,13.9,0,0,0,7.12-6.34"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M129.78,241.4a9.91,9.91,0,0,1-3.58,17.1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121,193.47a2.11,2.11,0,0,0-2.09.14,2.66,2.66,0,0,0-1.13,1.8,3.07,3.07,0,0,0,2.56,3.41,3,3,0,0,0,3.16-2.8C123.53,194.44,121.89,193.05,121,193.47Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.41,163.58A173.26,173.26,0,0,0,117,183.7c.16,1.77.66,3.92,2.38,4.37a3,3,0,0,0,3.27-1.94,8.89,8.89,0,0,0,.4-4.08l-.9-14.64c-.1-1.71-.25-3.55-1.36-4.84s-3.55-1.54-4.36,0a3.9,3.9,0,0,0-.33,1.73,113.63,113.63,0,0,0,.89,19.16"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.91,195.61a2.13,2.13,0,0,0-.78-2,2.61,2.61,0,0,0-2.06-.51,3.06,3.06,0,0,0-2.45,3.48,2.93,2.93,0,0,0,3.63,2.14C134.76,198.28,135.57,196.29,134.91,195.61Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.56,163.45a173.49,173.49,0,0,0-.21,20.14c.09,1.77.5,3.94,2.2,4.46a3,3,0,0,0,3.35-1.8,8.82,8.82,0,0,0,.56-4.06l-.28-14.67c0-1.71-.11-3.55-1.17-4.89s-3.47-1.69-4.35-.22a3.84,3.84,0,0,0-.4,1.71,113.86,113.86,0,0,0,.09,19.19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel3G);
export default __webpack_public_path__ + "static/media/Idea_Panel_3g.46128899b57a853fb3de140668bae114.svg";
export { ForwardRef as ReactComponent };